const notSingleKey = (eventId) => `dealbreakersNotSingle_${eventId}`;

export const isNotSingle = (eventId) => {
  if (!eventId) return false;
  try {
    return localStorage.getItem(notSingleKey(eventId)) === "true";
  } catch (e) {
    return false;
  }
};

export const setNotSingle = (eventId) => {
  if (!eventId) return;
  try {
    localStorage.setItem(notSingleKey(eventId), "true");
  } catch (e) {
    /* no-op */
  }
};

export const clearNotSingle = (eventId) => {
  if (!eventId) return;
  try {
    localStorage.removeItem(notSingleKey(eventId));
  } catch (e) {
    /* no-op */
  }
};
